import styled from 'styled-components';
import breakpoints from '../breakpoints';

export const TextBlock = styled.div`
    color: ${({ color }) => color || '#2A2A33'};
    flex-basis: 100%;
    font-family: 'Open Sans', sans-serif;
    font-size: 16px;
    font-weight: normal;
    line-height: 22px;
    margin: ${({ margin }) => (margin || '16px auto 0 auto')};
    max-width: ${({ maxWidth }) => (maxWidth || undefined)};
    padding: ${({ padding }) => (padding || 0)};
    text-align: center;

    @media ${breakpoints.small} {
        text-align: ${({ forceAlign }) => forceAlign || 'center'};
    }

    @media ${breakpoints.large} {
        text-align: ${({ forceAlign }) => forceAlign || 'left'};
    }

    @media ${breakpoints.extraLarge} {
        text-align: ${({ forceAlign }) => forceAlign || 'left'};
        max-width: 100%;
    }
`;
